"use client";

import type { ComponentType } from "react";
import {
	Chip as ChipComponent,
	Heading,
	type ChipProps
} from "@pamperedchef/design-system";

import * as styles from "./CategoryChips.module.scss";

const Chip = ChipComponent as unknown as ComponentType<ChipProps>;

export interface CategoryChip {
	label: string;
	href: string;
}

export interface CategoryChipsProps {
	heading?: string;
	links: CategoryChip[];
	/** Navigation stays with the caller; composites do not touch `window`. */
	onLinkPress?(link: CategoryChip): void;
}

export function CategoryChips({
	heading,
	links,
	onLinkPress
}: CategoryChipsProps): JSX.Element | null {
	if (links.length === 0) return null;

	return (
		<section className={styles["chips"]} data-component="CategoryChips">
			{heading ? (
				<Heading tag="h2" className={styles["chips__heading"]}>
					{heading}
				</Heading>
			) : null}
			<ul className={styles["chips__list"]}>
				{links.map((link) => (
					<li key={link.href}>
						<Chip
							kind="outline"
							size="xl"
							label={link.label}
							data-href={link.href}
							onPress={() => onLinkPress?.(link)}
						/>
					</li>
				))}
			</ul>
		</section>
	);
}
